import { Koi } from '@ksyos/koi';
import type { TypedSchema } from '@common/validation/utils/typedSchemaType';
import { addAllowNull } from '@common/validation/utils/addAllowNull';
import type { BariPreNurseSpecialistMedScreeningReportDataV1 } from './bariPreNurseSpecialistMedScreeningReportDataV1';
import {
    bariPreNurseSpecialistMedScreeningReportBaseDraft,
    bariPreNurseSpecialistMedScreeningReportBaseFinal,
    ComorbiditeitenFinal,
} from '../bariPreNurseSpecialistMedScreeningReportSchema';

export const bariPreNurseSpecialistMedScreeningReportFinalV1: TypedSchema<BariPreNurseSpecialistMedScreeningReportDataV1> =
    {
        ...bariPreNurseSpecialistMedScreeningReportBaseFinal,
        ...ComorbiditeitenFinal,
    };

export const bariPreNurseSpecialistMedScreeningReportDraftV1: TypedSchema<BariPreNurseSpecialistMedScreeningReportDataV1> =
    {
        ...addAllowNull(ComorbiditeitenFinal),
        ...bariPreNurseSpecialistMedScreeningReportBaseDraft,
    };

export const bariPreNurseSpecialistMedScreeningReportDraftSchemaV1 = Koi.object(
    bariPreNurseSpecialistMedScreeningReportDraftV1
);
export const bariPreNurseSpecialistMedScreeningReportFinalSchemaV1 = Koi.object(
    bariPreNurseSpecialistMedScreeningReportFinalV1
);
